import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Role } from '@models/role.model';
import RoleMappingService from '@services/role.service';
import { Page } from '@models/page';
import { RoleType } from '@enums/role-type.enum';
import { RolesContext, RolesContextType } from '@contexts/roles-context';

export default function RolesContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [roles, setRoles] = useState<Role[] | undefined>(undefined);

  useEffect(() => {
    RoleMappingService.getRoles().then((res: Page<Role>) => {
      setRoles(res.content);
    });
  }, []);

  const getRoleBasedOnType = useCallback(
    (roleType: RoleType) => {
      return roles?.find((role) => role.name === roleType);
    },
    [roles],
  );

  const getRoleBasedOnId = useCallback(
    (roleId: number) => {
      return roles?.find((role) => role.id === roleId);
    },
    [roles],
  );

  return (
    <>
      {roles && (
        <RolesContext.Provider
          value={
            {
              roles,
              getRoleBasedOnId,
              getRoleBasedOnType,
            } as RolesContextType
          }>
          {children}
        </RolesContext.Provider>
      )}
    </>
  );
}

export const useRoles = () => {
  const context = useContext(RolesContext);
  return context;
};
